import React from "react";
import styled from "styled-components";

const Empty = styled.div`
  padding: 64px 0 32px;
  max-width: 560px;
`;

const HeroNumber = styled.div`
  font-family: 'Doto', 'Space Mono', monospace;
  font-size: 120px;
  font-weight: 700;
  line-height: 0.9;
  color: var(--nd-text-display);
  letter-spacing: -0.03em;
  margin-bottom: 32px;
  @media (max-width: 768px) {
    font-size: 80px;
  }
`;

const Subtitle = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: var(--nd-text-display);
  letter-spacing: -0.02em;
  line-height: 1.15;
  margin: 0 0 12px;
`;

const Body = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 16px;
  font-weight: 300;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0;
`;

const EmptyMap = () => (
  <Empty>
    <HeroNumber>—</HeroNumber>
    <Subtitle>No active projects yet</Subtitle>
    <Body>
      Once a junior is assigned to an active project with a declared tech
      stack, the map will populate here.
    </Body>
  </Empty>
);

export default EmptyMap;
